import { DEFAULT_RESUME_BUILDER_BASE_PATH } from '@glass/common/modules/pages/paths';

// this is for blog links that are using the full url
const testOrigin = 'https://rocket-resume.com';

const replaceResumeBuilderBasePath = (str, resumeBuilderBasePath) =>
  str?.replace(`/${DEFAULT_RESUME_BUILDER_BASE_PATH}`, `/${resumeBuilderBasePath}`);

const getInternalHref = (href, { defaultBuilderBasePath } = {}) => {
  if (!href || typeof href !== 'string') {
    return null;
  }

  if (href[0] === '/') {
    if (defaultBuilderBasePath) {
      return replaceResumeBuilderBasePath(href, defaultBuilderBasePath);
    }
    return href;
  }

  if (href.startsWith(testOrigin)) {
    const removed = href.replace(testOrigin, '');
    if (defaultBuilderBasePath) {
      return replaceResumeBuilderBasePath(removed, defaultBuilderBasePath);
    }
    return removed;
  }

  return null;
};

export default getInternalHref;
